<p-toast [key]="toastKey" position="top-center">
  <ng-template let-message #message>
    <div class="navigation-error-toast flex flex-column gap-2 flex-1" data-testid="nav-error-reload-toast">
      <span class="font-semibold" data-testid="nav-error-reload-title">{{ 'common.navigationError.title' | translate }}</span>
      <span data-testid="nav-error-reload-detail">{{ 'common.navigationError.detail' | translate }}</span>
      <p-button
        data-testid="nav-error-reload-btn"
        size="small"
        styleClass="align-self-start"
        [outlined]="false"
        [label]="'common.navigationError.reload' | translate"
        (onClick)="onReload(message)"
      />
    </div>
  </ng-template>
</p-toast>
